import PageLayout from '@/components/PageLayout';
import { NavBarLightTheme } from '@/components/PageLayout/PageNavBar';
import TwelveColGrid from '@/components/TwelveColGrid';
export default function PrivacyPolicyPage() {
  return (
    <PageLayout>
      <NavBarLightTheme />
      <TwelveColGrid gap="gap-2.4" my="my-6.4">
        <h1 className="col-span-12 font-medium copy-xl">OLEA PRIVACY POLICY</h1>
        <p className="col-span-12 text-s">
          Privacy is important to OLEA Collection, Inc. The following describes
          the information we collect and the ways we use that information. By
          using www.olea.art (the “Website”), our Shopify store
          www.olea.art/shop and www.shop.olea.art, our community forums as
          community.olea.art and engaging with our services (collectively, the
          “Services”), you are consenting to the collection, use, sharing, and
          storage of your personal information, as described below. This Privacy
          Policy supplements and is incorporated into our Terms of Service
          which, together with this Privacy Policy, govern your use of the
          Services. We have endeavored to make this Privacy Policy as clear as
          possible. If, however, you have any questions, comments or concerns
          about this Privacy Policy, please send us an email at info@olea.art.
          The term “OLEA Collection, Inc.” or ”OLEA” or “us” or “we” or “our”
          refer to OLEA Collection, Inc., the owner of the Services. The terms
          “you” or “your” refer to the user or viewer of the Services.
        </p>
        <h6 className="col-span-12 font-medium uppercase copy-l">
          INFORMATION WE COLLECT
        </h6>
        <p className="col-span-12 text-s">
          We collect information from those who visit and interact with our
          Services. This information may include the following: full name, email
          address, mailing address, and phone number; order and payment
          information; and comments, requests, and other information you may
          offer. Through third parties, such as Shopify, Inc. (“Shopify”),
          Google Analytics, Google Tag Manager, Mailchimp and Instagram we may
          also collect other identifiable and non-identifiable information
          related to your access to our services, including, but not limited to,
          your IP address, search queries, video and Services visits, page
          response times, download errors, length of visits to certain pages,
          and page interaction information. We collect the above information
          directly from you when you provide it to us, automatically as you
          navigate the Services, and from third-party service providers.
        </p>
        <h6 className="col-span-12 font-medium uppercase copy-l">
          HOW WE USE THIS INFORMATION
        </h6>
        <p className="col-span-12 text-s">
          We use this information to facilitate the provision of your requested
          services, such as fulfilling orders and requests made through the
          Services. We also use this information to track user behavior, improve
          our products and services, and generate customer related statistics.
        </p>
        <h6 className="col-span-12 font-medium uppercase copy-l">
          SHARING YOUR INFORMATION
        </h6>
        <p className="col-span-12 text-s">
          We do not ever sell your personal information for commercial purposes.
          By using the Website and our Shopify store, some of your information
          is collected and used by Shopify. Shopify&apos;s collection and use of
          your information is subject to their privacy policy, which can be
          found at https://www.shopify.com/legal/privacy. We may also share
          information with third parties in limited circumstances, such as
          complying with legal processes, cooperating with law enforcement,
          preventing fraud or imminent harm, ensuring the security of our
          network and services, when we believe your actions violate our Terms
          of Service, or in the event we are transferred or sold to another
          entity as a result of a corporate sale, merger, consolidation, asset
          sale, or in the unlikely event of bankruptcy.
        </p>
        <h6 className="col-span-12 font-medium uppercase copy-l">
          THIRD PARTIES
        </h6>
        <p className="col-span-12 text-s">
          Your information may be held by third parties or we may link to other
          sites or applications not affiliated, owned, or controlled by us.
          Further, we may use products and services of third parties, for which
          the disclosure of your information is necessary, to help us better
          provide our services to you. These third parties include Shopify,
          Google Analytics, Google Tag Manager, Mailchimp, Vanilla and
          Instagram. We expressly disclaim any and all liability for the actions
          of third parties. The privacy practices of any third parties are
          outside the scope of this Privacy Policy and their use or disclosure
          of your information (including your personal information) will be
          governed by their own privacy practices or policies. We encourage you
          to review the privacy practices or policies of those third parties.
        </p>
        <h6 className="col-span-12 font-medium uppercase copy-l">
          YOUR RIGHTS
        </h6>
        <p className="col-span-12 text-s">
          If you would like to access, modify, or delete your personal
          information, you may submit a request to info@olea.art. California
          residents may have additional personal information rights. For more
          information or to see if these rights apply to you, please contact us.
          We will promptly review all such requests in accordance with
          applicable laws.
        </p>
        <h6 className="col-span-12 font-medium uppercase copy-l">
          RIGHTS FOR PERSONS COVERED BY GDPR
        </h6>
        <p className="col-span-12 text-s">
          If you are “data subject” for whom the processing of personal
          information is subject to REGULATION (EU) 2016/679 (GDPR) (“Covered
          Person”), the rights described in sections (A) through (G) apply to
          you. (A) Right of access, rectification, erasure and restriction of
          processing: you may obtain access to your personal information stored
          by us by contacting us. If we process or use your personal
          information, we shall endeavor to ensure, by implementing suitable
          measures, that your personal information is accurate and up to date
          for the purposes for which they were collected. If your personal
          information is inaccurate or incomplete, you may obtain the
          rectification of such personal information by contacting us. You may
          obtain the erasure or restriction of processing of your personal
          information in situations where no legitimate business purpose exists
          or the further storage is unnecessary under statutory storage
          obligations. (B) Right to data portability: you may receive the
          personal information about you that you have provided to us, in a
          structured, commonly used and machine-readable format or transmit this
          information to another controller. To exercise this right, contact us.
          (C) Right to object: you may object, on grounds relating to your
          particular situation, to the processing of your personal information.
          To exercise this right, you must contact us as provided herein. To the
          extent your personal information is processed for reasons other than
          direct marketing, you understand and agree that we have compelling
          legitimate reasons for information processing, such as providing
          access to our Services. You may use ad-blocking software to limit
          information capture and usage. You may also contact us with questions
          about this policy or to make a removal request. Making a request does
          not guarantee that the request will be honored. (D) Right to withdraw
          your consent: If you have given your consent to the collection or
          processing of your personal information, you may withdraw your consent
          without affecting the lawfulness of processing based on consent before
          its withdrawal by contacting us in writing. (E) We currently store
          your personal information in the United States, but your personal
          information may be transferred, stored, or processed in a location
          outside of the United States. (F) If you make a request under sections
          (A) – (D), above, we have 30 days to respond to you. To exercise any
          of these rights, please contact us. (G) The legal basis for processing
          your personal information is: (i) The collection of your data is
          necessary for the performance of our contractual relationship. (ii)
          Processing is necessary in order for us to comply with legal
          obligations.
        </p>
        <h6 className="col-span-12 font-medium uppercase copy-l">
          CHILDREN&apos;S ONLINE PRIVACY PROTECTION ACT
        </h6>
        <p className="col-span-12 text-s">
          The Services are intended for general audiences and are not directed
          to children under 13 years old. We do not target the Services to
          children under 13, and we do not intentionally collect any information
          from users under 13. If you become aware that your child has used the
          Services, and we may have personal information about a user under 13,
          please contact us at info@olea.art, so we may delete the information.
        </p>
        <h6 className="col-span-12 font-medium uppercase copy-l">COOKIES</h6>
        <p className="col-span-12 text-s">
          Cookies are small bits of electronic information that a website or
          application sends to your browser and are stored on your hard drive.
          We use cookies to identify users, track your behavior on the Website,
          keep the Services secure, and improve the Services&apos; performance.
          Some cookies are necessary in order to use the Services, and these
          cannot be disabled. Other cookies are not required to browse our
          Services and may be disabled or deleted, but this may prevent you from
          properly using the Services. Third-party services, such as Shopify,
          may employ cookies on the Services in order to better perform their
          services. Shopify&apos;s Cookie Policy can be found here. The Services
          also use the following third-party services, which use cookies: Google
          Analytics and Google Tag Manager (to collect visitor information and
          usage); Mailchimp (email, marketing and communications) Instagram (for
          social media engagement statistics) and Vanilla (forums and
          community). These third-party cookies may be used automatically as you
          navigate the Services, and some of these third-party cookies may be
          utilized if you are logged in to these third-party services while also
          using our Services. We have no control over third-party cookies, and
          therefore, disclaim any and all liability related to third-party
          cookies.
        </p>
        <h6 className="col-span-12 font-medium uppercase copy-l">
          CHANGES AND UPDATES TO PRIVACY POLICY
        </h6>
        <p className="col-span-12 text-s">
          This Privacy Policy may be revised periodically, and this will be
          reflected by the date above. Please revisit this page to stay aware of
          any changes. Your continued use of the Services constitutes your
          agreement to this Privacy Policy and any future revisions.
        </p>
        <h6 className="col-span-12 font-medium uppercase copy-l">
          CONTACT INFORMATION
        </h6>
        <p className="col-span-12 text-s">
          If you have any questions or concerns about this Privacy Policy,
          please contact us by email using the following information:
          info@olea.art
        </p>
      </TwelveColGrid>
    </PageLayout>
  );
}
